import type { Nullable } from "@iot-platform/core";
import { ToastManagerRepository } from "@iot-platform/core";
import type { User, UserCreate } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class UserCreateUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(user: UserCreate): Promise<Nullable<User>> {
        const creationResult = await this.userRepository.create(user);

        if (creationResult.isErr()) {
            const error = creationResult.error.message;
            ToastManagerRepository.error(error);
        }

        return creationResult.match(
            (userResult) => userResult,
            () => null,
        );
    }
}
